import { render, staticRenderFns } from "./ManufacturerSelect.vue?vue&type=template&id=03ea5cb0"
import script from "./ManufacturerSelect.vue?vue&type=script&lang=ts"
export * from "./ManufacturerSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports